import {
  collection,
  getDocs,
  query,
  orderBy,
  db
} from '../config/firebase';
import { transformDocument } from './firestoreService';
import { getBonusQuestionsPath } from './firestorePaths';

/**
 * BonusQuestionService
 * Handles operations for bonus_questions subcollection
 */
class BonusQuestionService {
  /**
   * Fetch all bonus questions for a party, ordered by bonus_question_id descending
   * @param {string} oscarsPartyId - The Oscar party document ID
   * @returns {Promise<Array<BonusQuestionModel>>} Array of bonus question models
   */
  async fetchBonusQuestions(oscarsPartyId) {
    try {
      const bonusQuestionsRef = collection(db, getBonusQuestionsPath(oscarsPartyId));
      const q = query(bonusQuestionsRef, orderBy('bonus_question_id', 'desc'));
      const querySnapshot = await getDocs(q);

      const bonusQuestions = [];
      querySnapshot.forEach((docSnapshot) => {
        const bonusQuestionData = transformDocument(docSnapshot.id, docSnapshot.data());
        bonusQuestions.push(bonusQuestionData);
      });

      return bonusQuestions;
    } catch (error) {
      console.error('Error fetching bonus questions:', error);
      throw error;
    }
  }
}

// Export singleton instance
export default new BonusQuestionService();
